import type { CaptureResult } from 'posthog-js'

const THIRD_PARTY_SCRIPT_HOSTS = ['cdn.userway.org']

const OPAQUE_EXCEPTION_VALUES = [
  /^script error\.?$/i,
  /captured as exception with keys/i
]

type ExceptionFrame = {
  filename?: string
}

type ExceptionItem = {
  value?: string
  stacktrace?: {
    frames?: ExceptionFrame[]
  }
}

const isThirdPartyFrame = (frame: ExceptionFrame) =>
  THIRD_PARTY_SCRIPT_HOSTS.some(host => frame.filename?.includes(host))

const comesOnlyFromThirdPartyScript = (exception: ExceptionItem) => {
  const frames = exception.stacktrace?.frames ?? []

  return frames.length > 0 && frames.every(isThirdPartyFrame)
}

const hasNoUsableStack = (exception: ExceptionItem) =>
  OPAQUE_EXCEPTION_VALUES.some(pattern => pattern.test(exception.value ?? ''))

const isUnactionable = (exception: ExceptionItem) =>
  comesOnlyFromThirdPartyScript(exception) || hasNoUsableStack(exception)

const dropUnactionableExceptions = (event: CaptureResult | null) => {
  if (!event || event.event !== '$exception') return event

  const exceptions = event.properties?.$exception_list as
    | ExceptionItem[]
    | undefined

  if (!exceptions?.length) return event

  return exceptions.every(isUnactionable) ? null : event
}

export default dropUnactionableExceptions
